import { EntityDetail_EntityFragment } from '@/modules/entities/details/graphql/EntityDetailPage.generated';
import { EntityKind } from '@/types/schema';

import { TIME_BOUND_ENTITY_KINDS } from '../entities.constants';

export function isEntityTimeBound(
  entity: { kind: EntityKind } | undefined | null
): boolean {
  if (!entity) return false;
  return TIME_BOUND_ENTITY_KINDS.includes(entity.kind);
}

export function getDeathOrderNotesForDecedent(
  entity: EntityDetail_EntityFragment,
  decedentId: string | null | undefined
) {
  if (!entity) return null;
  if (isEntityTimeBound(entity) || entity.syncDeathOrderNotes) {
    // time bound entities don't have a client profile on their notes
    return entity.deathOrderNotes?.find(({ clientProfile }) => !clientProfile);
  }
  return entity.deathOrderNotes?.find(
    ({ clientProfile }) => clientProfile?.id === decedentId
  );
}

export function getEntityNotesForDeath(
  entity: EntityDetail_EntityFragment,
  decedentId: string | null | undefined
): string | null {
  const deathOrderNotesForClientProfile = getDeathOrderNotesForDecedent(
    entity,
    decedentId
  );
  return deathOrderNotesForClientProfile?.notes ?? null;
}
